import { Document } from '@extrahorizon/javascript-sdk';
import { IconType } from 'react-icons';
import { Indicator } from 'utils/models';
import { BsCheckCircleFill, BsExclamationCircleFill, BsQuestionCircleFill } from 'react-icons/bs';
import { HeartRhythmMeasurementDiagnosis } from './measurementDiagnosis';
import { MeasurementData } from '../measurement';

export enum HeartRhythmMeasurementStatus {
  Measured = 'measured',
  PreprocessingSelection = 'preprocessing_selection',
  AnalysisSelection = 'analysis_selection',
  PendingAnalysis = 'pending_analysis',
  UnderAnalysis = 'under_analysis',
  AnalysisFailed = 'analysis_failed',
  ProcessingResults = 'processing_results',
  Analyzed = 'analyzed',
  PendingReview = 'pending_review',
  Reviewed = 'reviewed',
}

export type HeartRhythmMeasurement = Document<MeasurementData, HeartRhythmMeasurementStatus>;

export interface ReviewHeartRhythmMeasurementProps {
  measurement?: HeartRhythmMeasurement;
  label?: HeartRhythmMeasurementDiagnosis;
  text?: string;
  transitionId?: string;
}

interface IndicatorConfig {
  color: string;
  filterName: string;
  Icon?: IconType;
}

export const HeartRhythmMeasurementIndicatorMap: { [key in Indicator]: IndicatorConfig } = {
  urgent: { color: 'var(--mantine-color-red-5)', filterName: 'red', Icon: BsExclamationCircleFill },
  warning: { color: 'var(--mantine-color-peach-7)', filterName: 'orange', Icon: BsExclamationCircleFill },
  normal: { color: 'var(--mantine-color-turquoise-5)', filterName: 'green', Icon: BsCheckCircleFill },
  quality: { color: 'var(--mantine-color-blue-5)', filterName: 'blue', Icon: BsQuestionCircleFill },
  inconclusive: { color: 'var(--mantine-color-dark-2)', filterName: 'dark', Icon: BsQuestionCircleFill },
  no_result: { color: 'var(--mantine-color-gray-5)', filterName: 'gray', Icon: BsQuestionCircleFill },
  result_unavailable: { color: 'var(--mantine-color-gray-5)', filterName: 'gray', Icon: BsQuestionCircleFill },
};
